import React from 'react';
import { PropTypes } from 'prop-types';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

const SocialIcon = ({ styles, src, link, inNavigation }) => {
    const Icon = src;

    const className = getPlausibleClassName(
        styles.container,
        inNavigation ? AnalyticsEvent.BURGER_MENU_SOCIAL_CLICK : AnalyticsEvent.FOOTER_SOCIAL_CLICK,
        { click_url: link },
    );

    return (
        <a target="_blank" className={className} rel="noopener noreferrer" href={link}>
            <Icon className={styles.icon} />
        </a>
    );
};

SocialIcon.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    src: PropTypes.func.isRequired,
    link: PropTypes.string.isRequired,
    inNavigation: PropTypes.bool,
};

export default SocialIcon;
